import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import Nav from "react-bootstrap/Nav";
import { toast } from "react-toastify";
import { Badge, Tab, Spinner } from "react-bootstrap"; // Added Spinner
import moment from "moment";

import { useAuth } from "../../../firebase/AuthProvider";
import { getTasks } from "../../../services/taskServices/TaskService";
import TaskList from "../../../interfaces/task/TaskList";
import { TeamUser } from "../../../interfaces/team/TeamUser";
import { selectedUserForTask$ } from "../../../services/Subjects/userSubject";
import { AgingReportDto, AgingReportFilterReqDto, AgingStatusDto } from "../../../interfaces/agingReport/agingReport";
import { getAgingReportAsync, GetAgingStatusesAsync } from "../../../services/agingService/agingService";
import EditAgingModal from "../agingReport/modals/EditAgingModal";
import { GetEmergencySurveyStatusListAsync } from "../../../services/surveyService/SurveyService";
import { SurveyStatusItemDto } from "../../../interfaces/survey/SurveyDtos";
import "./Hometabs.css";
import "../participant-snapshot/ParticipantSnapshot.css";

// Import new sub-components
import Adminrequeststab from "../adminRequestsTab/AdminRequestsTab";
import HomeTaskTab from "./tabs/HomeTaskTab";
import HomeAgingTab from "./tabs/HomeAgingTab";
import HomeEmergencyTab from "./tabs/HomeEmergencyTab";

// Coming Soon Component for cleaner JSX
const ComingSoonTab = () => (
  <div className="common_content_inner mby_t_24 relative min-h-[17.5rem]">
    <div className="task-list-container center-content coming-soon-wrapper">
      <div className="coming-soon-content">
        <div className="icon-wrapper">
          <svg xmlns="http://www.w3.org/2000/svg" width="19" height="22" viewBox="0 0 19 22" fill="none">
            <path d="M15.26 6.24L16.75 4.75M15.26 6.24C13.6659 4.64594 11.5043 3.75 9.25 3.75C6.99566 3.75 4.83365 4.64553 3.23959 6.23959C1.64553 7.83365 0.75 9.99566 0.75 12.25C0.75 14.5043 1.64553 16.6663 3.23959 18.2604C4.83365 19.8545 6.99566 20.75 9.25 20.75C11.5043 20.75 13.6663 19.8545 15.2604 18.2604C16.8545 16.6663 17.75 14.5043 17.75 12.25C17.75 9.99566 16.8541 7.83406 15.26 6.24Z" stroke="#747474" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
            <path d="M9.25 17.75C7.79131 17.75 6.39236 17.1705 5.36091 16.1391C4.32946 15.1076 3.75 13.7087 3.75 12.25C3.75 10.7913 4.32946 9.39236 5.36091 8.36091C6.39236 7.32946 7.79131 6.75 9.25 6.75M11.75 0.75H6.75M9.25 12.25L12.75 8.75" stroke="#747474" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
          </svg>
        </div>
        <p className="coming-soon-text">Coming Soon</p>
      </div>
    </div>
  </div>
);

const Hometabs = () => {
  const { currentUser, currentOrganization, currentRoles } = useAuth();
  const navigate = useNavigate();
  
  // Loading States
  const [loading, setLoading] = useState<boolean>(false); // Used for Main Tasks
  const [isLoadingReview, setIsLoadingReview] = useState<boolean>(false);
  const [isLoadingAging, setIsLoadingAging] = useState<boolean>(false);
  const [isLoadingSurveys, setIsLoadingSurveys] = useState<boolean>(false);

  const [tasks, setTasks] = useState<TaskList[]>([]);
  const [aginReport, setAginReport] = useState<AgingReportDto[]>([]);
  const [activeTab, setActiveTab] = useState("tasks");
  const [selectedUsers, setSelectedUsers] = useState<TeamUser[]>([]);
  const [highestRole, setHighestRole] = useState<string>("--");
  const [surveys, setSurveys] = useState<SurveyStatusItemDto[]>([]);
  const [reviewTasks, setReviewTasks] = useState<TaskList[]>([]);

  // Counts
  const [tasksTotalCount, setTasksTotalCount] = useState<number>(0);
  const [reviewTasksTotalCount, setReviewTasksTotalCount] = useState<number>(0);
  const [agingReportTotalCount, setAgingReportTotalCount] = useState<number>(0);
  const [surveysTotalCount, setSurveysTotalCount] = useState<number>(0);

  // Modals
  const [showEditAgingModal, setShowEditAgingModal] = useState<boolean>(false);
  const [selectedAging, setSelectedAging] = useState<AgingReportDto | null>(null);
  const [agingStatuses, setAgingStatuses] = useState<AgingStatusDto[]>([]);

  // Tooltips
  const [showTooltip, setShowTooltip] = useState(false);
  const [showTooltip1, setShowTooltip1] = useState(false);
  const [showTooltip2, setShowTooltip2] = useState(false);
  const [showTooltip3, setShowTooltip3] = useState(false);

  // Constants
  const taskStatusFilter = ["Pending Extension", "ISSUES FOUND", "IN PROGRESS"];
  const excludeStatusforHighRoleSC = ["IN REVIEW", "IN REVIEW (SUP)", "IN REVIEW (PM)", "Pending Extension", "Waiver Changed", "PENDING DELETION"];

  // --- Helper Functions ---
  const getHighestRole = () => {
    if (!currentRoles) return "--";
    const roleOrder = ["ADMIN", "OWNER", "PROGRAM MANAGER", "SUPERVISOR", "SC", "ASSESSOR"];
    for (const role of roleOrder) {
      if (currentRoles.some((r) => r.name === role)) return role;
    }
    return currentRoles[0]?.name || "--";
  };

  const dateFiltersByRole = (role?: string) => {
    if (role === "OWNER") return ["overdue"];
    return ["overdue", "today", "week"];
  };

  // --- Effects ---
  useEffect(() => {
    if (!currentUser) return;
    const subscription = selectedUserForTask$.subscribe(async (users: TeamUser[]) => {
      try {
        if (!currentUser) return;
        const token = await currentUser.getIdToken();
        setSelectedUsers(users);
        if (users.length > 0) {
          getTaskofSelectedUsers(users, token);
        } else {
          GetTasksFromService(token);
        }
      } catch (error) {
        console.error("Error in user subscription:", error);
      }
    });
    return () => subscription.unsubscribe();
  }, [currentUser]);

  useEffect(() => {
    setHighestRole(getHighestRole());
  }, [currentRoles]);

  useEffect(() => {
    if (!currentUser || !currentRoles) return;
    const uid = selectedUsers.length > 0 ? selectedUsers[0].id : (currentUser?.uid || "");
    if (uid) {
      const currentHighestRole = getHighestRole();
      const minAgingDays = (currentHighestRole === "OWNER") ? 30 : null;
      getAgingReport(uid, minAgingDays);
    }
  }, [activeTab, highestRole, selectedUsers, currentUser, currentRoles]);

  useEffect(() => {
    if (!currentUser || !highestRole) return;
    if (highestRole === "SUPERVISOR" || highestRole === "PROGRAM MANAGER") {
      currentUser.getIdToken().then((token) => {
        getReviewTasks(token, selectedUsers);
      }).catch(console.error);
    } else {
      setReviewTasks([]);
    }
  }, [highestRole, selectedUsers, currentUser]);

  useEffect(() => {
    const fetchAgingStatuses = async () => {
      if (!currentUser) return;
      try {
        const token = await currentUser.getIdToken();
        const res = await GetAgingStatusesAsync(token);
        if (res.success) setAgingStatuses(res.data);
      } catch (error) { console.error(error); }
    };
    fetchAgingStatuses();
  }, [currentUser]);

  useEffect(() => {
    if (["SC", "SUPERVISOR", "PROGRAM MANAGER"].includes(highestRole)) {
      fetchSurveys();
    }
  }, [highestRole]);

  // --- Data Fetching Logic ---
  const getTaskofSelectedUsers = async (users: TeamUser[], token: string) => {
    try {
      if (!currentUser) {
        console.error("currentUser is null, cannot fetch tasks");
        return;
      }
      const allSelectedUserTasks: TaskList[] = [];
      const allSelectedUserAgingTasks: TaskList[] = [];
      setLoading(true);
      setTasks([]);

      const freshToken = await currentUser.getIdToken();
      let totalCountSum = 0;

      const currentHighestRole = getHighestRole();
      const dateFilters = dateFiltersByRole(currentHighestRole);
      const dynamicStatuses = getDynamicStatusFilters(currentHighestRole);

      const includePendingApprovals = currentHighestRole !== "SC" &&
        currentHighestRole !== "PROGRAM MANAGER" &&
        currentHighestRole !== "--";

      for (const item of users) {
        const filtersForThisUser: any = {
          excludeTags: [],
          status: dynamicStatuses, // Use the dynamic list here
          date: dateFilters,
        };


        if (currentHighestRole === "SC") {
          filtersForThisUser.excludeStatus = excludeStatusforHighRoleSC;
        }

        const userIdToFetch = (currentUser.uid && item.id === currentUser.uid)
          ? undefined
          : item.id;

        const tasksForThisUser = await getTasks(
          freshToken,
          userIdToFetch,
          1,
          10,
          filtersForThisUser,
          "enddate",
          false,
          true,
          includePendingApprovals
        );

        if (tasksForThisUser?.tasks) {
          allSelectedUserTasks.push(...tasksForThisUser.tasks);
        }
        if (tasksForThisUser?.totalCount !== undefined) {
          totalCountSum += tasksForThisUser.totalCount;
        }

        const agingTasksForThisUser = await getTasks(
          freshToken,
          userIdToFetch,
          1,
          6,
          { tags: ["Initial"] },
          "enddate",
          false,
          false,
          false
        );
        if (agingTasksForThisUser?.tasks) {
          allSelectedUserAgingTasks.push(...agingTasksForThisUser.tasks);
        }
      }

      setTasksTotalCount(totalCountSum);
      setTasks(allSelectedUserTasks);
    } catch (error: any) {
      console.error("Error fetching tasks for selected users:", error);
      if (error?.response?.status === 401) {
        toast.error("Authentication expired. Please refresh the page.");
      }
    } finally {
      setLoading(false);
    }
  };

  const GetTasksFromService = async (authToken: string) => {
    try {
      if (!currentUser) {
        console.error("currentUser is null, cannot fetch tasks");
        return;
      }
      setLoading(true);
      const freshToken = await currentUser.getIdToken();

      const currentHighestRole = getHighestRole();
      const dateFilters = dateFiltersByRole(currentHighestRole);
      const dynamicStatuses = getDynamicStatusFilters(currentHighestRole);

      const userIdParam = undefined;

      const filtersForService: any = {
        excludeTags: [],
        status: dynamicStatuses, // Use the dynamic list here
        date: dateFilters,
      };


      if (currentHighestRole === "SC") {
        filtersForService.excludeStatus = excludeStatusforHighRoleSC;
      }

      const includePendingApprovals = currentHighestRole !== "SC" &&
        currentHighestRole !== "PROGRAM MANAGER" &&
        currentHighestRole !== "--";

      const response = await getTasks(
        freshToken,
        userIdParam,
        1,
        10,
        filtersForService,
        "enddate",
        false,
        true,
        includePendingApprovals
      );
      setTasks(response?.tasks || []);
      setTasksTotalCount(response?.totalCount || 0);
    } catch (error: any) {
      console.error("Error fetching tasks:", error);
      if (error?.response?.status === 401) {
        toast.error("Authentication expired. Please refresh the page.");
      } else {
        toast.error("error to get tasks");
      }
    } finally {
      setLoading(false);
    }
  };

  const getReviewTasks = async (token: string, users: TeamUser[]) => {
    if (!currentUser) return;
    const currentHighestRole = getHighestRole();
    if (!currentHighestRole) return;

    if (currentHighestRole !== "SUPERVISOR" && currentHighestRole !== "PROGRAM MANAGER" && currentHighestRole !== "OWNER" && currentHighestRole !== "ADMIN") {
      setReviewTasks([]);
      return;
    }

    // START LOADING REVIEW
    setIsLoadingReview(true);

    try {
      const freshToken = await currentUser.getIdToken();

      // UPDATED LOGIC HERE:
      const reviewStatuses = [];
      if (currentHighestRole === "OWNER" || currentHighestRole === "ADMIN") {
        // Owners and Admins still see both levels
        reviewStatuses.push("IN REVIEW (PM)");
        reviewStatuses.push("IN REVIEW (SUP)");
      } else if (currentHighestRole === "PROGRAM MANAGER") {
        // Program Managers now ONLY see PM-level review tasks
        reviewStatuses.push("IN REVIEW (PM)");
      } else {
        // Supervisors see SUP-level review tasks
        reviewStatuses.push("IN REVIEW (SUP)");
      }
      const allReviewTasks: TaskList[] = [];
      let reviewTotalCountSum = 0;

      if (users.length > 0) {
        for (const user of users) {
          const filtersForReview: any = {
            excludeTags: [],
            status: reviewStatuses
          };

          const userIdToFetch = (currentUser.uid && user.id === currentUser.uid)
            ? undefined
            : user.id;

          const response = await getTasks(
            freshToken,
            userIdToFetch,
            1,
            100,
            filtersForReview,
            "enddate",
            false,
            true,
            true
          );
          if (response?.tasks) {
            allReviewTasks.push(...response.tasks);
          }
          if (response?.totalCount !== undefined) {
            reviewTotalCountSum += response.totalCount;
          }
        }
      } else {
        const filtersForReview: any = {
          excludeTags: [],
          status: reviewStatuses
        };

        const userIdParam = undefined;

        const response = await getTasks(
          freshToken,
          userIdParam,
          1,
          100,
          filtersForReview,
          "enddate",
          false,
          false,
          true
        );
        if (response?.tasks) {
          allReviewTasks.push(...response.tasks);
        }
        if (response?.totalCount !== undefined) {
          reviewTotalCountSum = response.totalCount;
        }
      }

      setReviewTasksTotalCount(reviewTotalCountSum);

      const sortedReviewTasks = allReviewTasks.sort((a, b) => {
        const dateA = new Date(a.endDate).getTime();
        const dateB = new Date(b.endDate).getTime();
        return dateA - dateB;
      });

      setReviewTasks(sortedReviewTasks);
    } catch (error: any) {
      console.error("Error fetching review tasks:", error);
    } finally {
        setIsLoadingReview(false);
    }
  };

  const getAgingReport = async (uid: string, minAgingDays?: number | null) => {
    if (!currentUser) return;
    
    // START LOADING AGING
    setIsLoadingAging(true);

    try {
      const token = await currentUser.getIdToken();
      setAginReport([]);
      const res = await getAgingReportAsync({ regionIds: null, waiverIds: null, statusId: null, pageNumber: 1, pageSize: 100 }, uid, token, minAgingDays);
      if (res.success) {
        setAginReport(res.data.items);
        setAgingReportTotalCount(res.data.totalCount || 0);
      }
    } catch (error) { console.error(error); }
    finally { setIsLoadingAging(false); }
  };

  const fetchSurveys = async () => {
    if (!currentUser) return;
    
    // START LOADING SURVEYS
    setIsLoadingSurveys(true);

    const token = await currentUser.getIdToken();
    try {
      const res = await GetEmergencySurveyStatusListAsync(token, 1, 5, 0);
      if (res.success) {
        setSurveys(res.data.items);
        setSurveysTotalCount(res.data.totalCount || res.data.items.length);
      }
    } catch (err: any) { toast.error(err.message); }
    finally { setIsLoadingSurveys(false); }
  };

  const getWarningTasks = () => {
    let filtered = tasks.filter((t) => {
      const statusName = t.status?.name?.toUpperCase();
      return taskStatusFilter.some(status => statusName === status.toUpperCase());
    });
    return filtered.sort((a, b) => new Date(a.endDate).getTime() - new Date(b.endDate).getTime());
  };

  const getTasksForMainTab = () => {
    const dynamicStatuses = getDynamicStatusFilters(highestRole);

    let filtered = tasks.filter((t) => {
      const statusName = t.status?.name?.toUpperCase();
      return dynamicStatuses.some(status => status.toUpperCase() === statusName);
    });

    return filtered.sort((a, b) => new Date(a.endDate).getTime() - new Date(b.endDate).getTime());
  };
  
  const tabCounts = {
    tasks: tasksTotalCount,
    taskWarning: tasksTotalCount || getWarningTasks().length,
    agingReport: agingReportTotalCount || aginReport.length,
    toReview: reviewTasksTotalCount || reviewTasks.length,
    agingReview: agingReportTotalCount || aginReport.length,
    emergency: surveysTotalCount || surveys.length
  };

  const onClickStartSurvey = (surveyName: string, instanceId: string, participant_ID: string) => {
    switch (surveyName) {
      case "EMERGENCY_SURVEY_1": navigate(`/prestormsurvey/${participant_ID}/${instanceId}`); break;
      case "EMERGENCY_SURVEY_2": navigate(`/relocationsurvey/${participant_ID}/${instanceId}`); break;
      case "EMERGENCY_SURVEY_3": navigate(`/poststormsurvey/${participant_ID}/${instanceId}`); break;
    }
  };

  // --- URL Builders ---

  const getDynamicStatusFilters = (role: string) => {
    const baseFilters = ["Pending Extension", "ISSUES FOUND", "IN PROGRESS"];

    if (role === "OWNER" || role === "ADMIN") {
      return [...baseFilters, "IN REVIEW (SUP)", "IN REVIEW (PM)"];
    }

    if (role === "PROGRAM MANAGER") {
      return [...baseFilters, "IN REVIEW (SUP)"];
    }

    return baseFilters;
  };

  // 2. Update the buildTasksUrl function to use these dynamic statuses
  const buildTasksUrl = () => {
    if (!currentUser) return "/tasks";
    const params = new URLSearchParams();

    // Get dynamic statuses based on role
    const dynamicStatuses = getDynamicStatusFilters(highestRole);
    dynamicStatuses.forEach(s => params.append("status", s));

    const dates = dateFiltersByRole(highestRole);
    dates.forEach(d => params.append("date", d));

    params.append("sortBy", "enddate");
    params.append("sortDesc", "false");
    params.append("viewAll", "true");

    // Logic for includePendingApprovals
    const includePendingApprovals = highestRole !== "SC" &&
      highestRole !== "PROGRAM MANAGER" &&
      highestRole !== "--";
    params.append("includePendingApprovals", String(includePendingApprovals));

    if (highestRole === "SC") {
      excludeStatusforHighRoleSC.forEach(s => params.append("excludeStatus", s));
    }

    if (selectedUsers.length > 0) {
      params.append("userId", selectedUsers[0].id);
    }

    return `/tasks?${params.toString()}`;
  };

  // Inside Hometabs.tsx -> getReviewTasksUrl function

  const getReviewTasksUrl = () => {
    if (!currentUser) return "/tasks";
    const params = new URLSearchParams();

    if (highestRole === "OWNER" || highestRole === "ADMIN") {
      params.append("status", "IN REVIEW (PM)");
      params.append("status", "IN REVIEW (SUP)");
    } else if (highestRole === "PROGRAM MANAGER") {
      // Matches the updated tab logic
      params.append("status", "IN REVIEW (PM)");
    } else {
      params.append("status", "IN REVIEW (SUP)");
    }

    params.append("sortBy", "enddate");
    params.append("viewAll", "true");
    params.append("includePendingApprovals", "true");

    if (selectedUsers.length > 0) {
      params.append("userId", selectedUsers[0]?.id || "");
    }

    return `/tasks?${params.toString()}`;
  };

  // Helper component for Count vs Spinner
  const CountOrSpinner = ({ count, isLoading }: { count: number; isLoading: boolean }) => {
    if (isLoading) {
      return <Spinner animation="border" role="status" size="sm" style={{ width: '12px', height: '12px', borderWidth: '1px', marginLeft: '4px' }} />;
    }
    return <span className="tab-count-due">{count}</span>;
  };

  return (
    <>
      <div className="common_card" style={{ minHeight: "27.75rem" }}>
        {/* --- Header --- */}
        <div className="task-due-header">
          <span className="text-[16px] xl:text-[18px] 2xl:text-[20px] font-semibold">Tasks Due</span>
          <div>
            {activeTab === "tasks" && (
              <div className="task-due-viewall"><Link to={buildTasksUrl()} className="arrow_link">View All {">"}</Link></div>
            )}
            {activeTab === "aging-report" && (
              <div className="task-due-viewall">
                <Link to={(highestRole === "SUPERVISOR" || highestRole === "PROGRAM MANAGER") ? getReviewTasksUrl() : "/aging-report"} className="arrow_link">View All {">"}</Link>
              </div>
            )}
            {activeTab === "aging-review" && (
              <div className="task-due-viewall"><Link to="/aging-report" className="arrow_link">View All {">"}</Link></div>
            )}
            {activeTab === "admin-requests" && !["SUPERVISOR", "PROGRAM MANAGER", "SC"].includes(highestRole) && (
              <div className="task-due-viewall"><Link to="/admin-requests" className="arrow_link">View All {">"}</Link></div>
            )}
            {((activeTab === "admin-requests" && highestRole === "SC") || activeTab === "emergency-tracking") && (
              <div className="task-due-viewall"><Link to="/surveys/participant" className="arrow_link">View All {">"}</Link></div>
            )}
          </div>
        </div>

        {/* --- Tabs --- */}
        <Tab.Container id="left-tabs-example" defaultActiveKey="tasks" activeKey={activeTab} onSelect={(k) => setActiveTab(k || "tasks")}>
          <div className="tab_flx flex-wrap due-tab-bottom">
            <Nav variant="underline" className="task-due-tab">
              <Nav.Item>
                <Nav.Link eventKey="tasks">
                  {(highestRole === "SUPERVISOR" || highestRole === "PROGRAM MANAGER") ? "Task Warning" : (highestRole === "OWNER" ? "Late Tasks" : "To do")}
                  <CountOrSpinner 
                    count={highestRole === "SUPERVISOR" || highestRole === "PROGRAM MANAGER" ? tabCounts.taskWarning : tabCounts.tasks} 
                    isLoading={loading} 
                  />
                </Nav.Link>
              </Nav.Item>

              <Nav.Item>
                {highestRole !== "ASSESSOR" && (
                  <Nav.Link eventKey="aging-report">
                    {(highestRole === "SUPERVISOR" || highestRole === "PROGRAM MANAGER") ? "To Review" :
                      (highestRole === "SC" ? "Uncertified" : "Aging Report")}
                    <CountOrSpinner 
                        count={(highestRole === "SUPERVISOR" || highestRole === "PROGRAM MANAGER") ? tabCounts.toReview : tabCounts.agingReport}
                        isLoading={(highestRole === "SUPERVISOR" || highestRole === "PROGRAM MANAGER") ? isLoadingReview : isLoadingAging}
                    />
                  </Nav.Link>
                )}
              </Nav.Item>

              {(highestRole === "SUPERVISOR" || highestRole === "PROGRAM MANAGER") && (
                <Nav.Item>
                  <Nav.Link eventKey="aging-review">Aging Review <CountOrSpinner count={tabCounts.agingReview} isLoading={isLoadingAging} /></Nav.Link>
                </Nav.Item>
              )}

              {highestRole === "SC" && (
                <Nav.Item>
                  <Nav.Link eventKey="admin-requests" onMouseEnter={() => setShowTooltip2(true)} onMouseLeave={() => setShowTooltip2(false)}>
                    Emergency tracking <CountOrSpinner count={0} isLoading={isLoadingSurveys} />
                    {showTooltip2 && <div className="coming-soon-tooltip">Coming Soon</div>}
                  </Nav.Link>
                </Nav.Item>
              )}

              {(highestRole === "SUPERVISOR" || highestRole === "PROGRAM MANAGER") && (
                <Nav.Item>
                  <Nav.Link eventKey="emergency-tracking" onMouseEnter={() => setShowTooltip3(true)} onMouseLeave={() => setShowTooltip3(false)}>
                    Emergency Tracking <CountOrSpinner count={tabCounts.emergency} isLoading={isLoadingSurveys} />
                    {showTooltip3 && <div className="coming-soon-tooltip">Coming Soon</div>}
                  </Nav.Link>
                </Nav.Item>
              )}

              {highestRole === "OWNER" && (
                <>
                  <Nav.Item>
                    <Nav.Link eventKey="coming-soon" onMouseEnter={() => setShowTooltip(true)} onMouseLeave={() => setShowTooltip(false)}>
                      Delinquent CIR <span className="tab-count-due">0</span>
                      {showTooltip && <div className="coming-soon-tooltip">Coming Soon</div>}
                    </Nav.Link>
                  </Nav.Item>
                  <Nav.Item>
                    <Nav.Link eventKey="coming-soon1" onMouseEnter={() => setShowTooltip1(true)} onMouseLeave={() => setShowTooltip1(false)}>
                      Emergency Track <span className="tab-count-due">0</span>
                      {showTooltip1 && <div className="coming-soon-tooltip">Coming Soon</div>}
                    </Nav.Link>
                  </Nav.Item>
                </>
              )}
            </Nav>
          </div>

          <Tab.Content>
            <Tab.Pane eventKey="tasks">
              <HomeTaskTab
                tasks={getTasksForMainTab()}
                loading={loading}
                currentOrganization={currentOrganization}
                limit={highestRole === "ASSESSOR" ? 10 : 4}
              />
            </Tab.Pane>

            <Tab.Pane eventKey="aging-report">
              {(highestRole === "SUPERVISOR" || highestRole === "PROGRAM MANAGER") ? (
                <HomeTaskTab
                  tasks={reviewTasks}
                  loading={isLoadingReview} 
                  currentOrganization={currentOrganization}
                />
              ) : (
                <HomeAgingTab
                  reports={aginReport}
                  loading={isLoadingAging} 
                  onSelectReport={(item: any) => { setSelectedAging(item); setShowEditAgingModal(true); }}
                />
              )}
            </Tab.Pane>

            <Tab.Pane eventKey="aging-review">
              <HomeAgingTab
                reports={aginReport}
                loading={isLoadingAging} 
                onSelectReport={(item: any) => { setSelectedAging(item); setShowEditAgingModal(true); }}
              />
            </Tab.Pane>

            <Tab.Pane eventKey={["SC", "SUPERVISOR", "PROGRAM MANAGER"].includes(highestRole) ? "admin-requests" : "admin-requests-default"}>
              {(["SC", "SUPERVISOR", "PROGRAM MANAGER"].includes(highestRole)) ? (
                <HomeEmergencyTab
                  surveys={surveys}
                  highestRole={highestRole}
                  onStartSurvey={onClickStartSurvey}
                />
              ) : (
                <Adminrequeststab />
              )}
            </Tab.Pane>

            <Tab.Pane eventKey="emergency-tracking"><ComingSoonTab /></Tab.Pane>
            <Tab.Pane eventKey="coming-soon"><ComingSoonTab /></Tab.Pane>
            <Tab.Pane eventKey="coming-soon1"><ComingSoonTab /></Tab.Pane>
          </Tab.Content>
        </Tab.Container>
      </div>

      {showEditAgingModal && selectedAging && (
        <EditAgingModal
          showEditAgingModal={showEditAgingModal}
          handlCloseEditAgingModal={() => { setShowEditAgingModal(false); setSelectedAging(null); }}
          selectedAging={selectedAging}
          reload={() => {
            const uid = selectedUsers.length > 0 ? selectedUsers[0].id : currentUser?.uid || "";
            if (uid) {
              const currentHighestRole = getHighestRole();
              getAgingReport(uid, currentHighestRole === "OWNER" ? 30 : null);
            }
          }}
          statuses={agingStatuses}
        />
      )}
    </>
  );
};

export default Hometabs;